import { z } from 'zod'
import {
  CitySchema,
  EmailSchema,
  NameSchema,
  PhoneSchema,
  PostalCodeSchema,
  ProvinceSchema,
} from '@/schemas'
import { StreetSchema } from '@/schemas/streetSchema'

export const ChurchCreateSchema = z.object({
  name: NameSchema,
  address: z.object({
    street: StreetSchema,
    city: CitySchema,
    province: ProvinceSchema,
    postal: PostalCodeSchema,
  }),
  phone: PhoneSchema.optional(),
  email: EmailSchema.optional(),
  pastorId: z.string().optional(),
})

export const ChurchSchema = z.object({
  _id: z.string(),
  name: NameSchema,
  address: z.object({
    street: StreetSchema,
    city: CitySchema,
    province: ProvinceSchema,
    postal: PostalCodeSchema,
  }),
  phone: PhoneSchema.optional(),
  email: EmailSchema.optional(),
  pastorId: z.string().optional(),
  active: z.boolean().optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
})

export const ChurchUpdateSchema = z.object({
  _id: z.string(),
  name: NameSchema,
  address: z.object({
    street: StreetSchema,
    city: CitySchema,
    province: ProvinceSchema,
    postal: PostalCodeSchema,
  }),
  phone: PhoneSchema.optional(),
  email: EmailSchema.optional(),
  pastorId: z.string().optional(),
  active: z.boolean().optional(),
})

export type ChurchCreateData = z.infer<typeof ChurchCreateSchema>
export type ChurchUpdateData = z.infer<typeof ChurchUpdateSchema>
export type ChurchData = z.infer<typeof ChurchSchema>
